// @flow
import type { Dispatch, GetState } from 'state/types';
import { actions } from 'portfolio-shared/state/reducers/intlReducer';
import { persist } from 'state/commands/persistCommands';
import { USER_DATA } from 'util/constants';
import * as messages from 'translations';

const { setLocale: setLocaleAction, setMessages: setMessagesAction } = actions;

function setLocale(locale: string) {
  return async function setLocale(dispatch: Dispatch, getState: GetState) {
    await dispatch(persist({ [USER_DATA.LOCALE]: locale }));
    dispatch(setLocaleAction(locale));
  };
}

function setMessages(locale: string) {
  const localizedMessages = messages[locale] || messages['en'];
  return setMessagesAction(localizedMessages);
}

export { setLocale, setMessages };



// WEBPACK FOOTER //
// ./src/state/commands/intlCommands.js